/**
 * Field identifier for dynamic task ID filters.
 *
 * This is NOT added to the FilterTypes enum or FilterFields map because:
 * - It's not a user-selectable predefined filter option
 * - It doesn't map to a real ITask property
 * - It doesn't need aria labels, filter counts, or menu rendering
 *
 * Used as the Filter.field discriminator in applyTaskFilter()
 * and for persistence exclusion during serialization.
 */ export const DynamicFilterField = "dynamicTaskIds";
/**
 * Filter fields excluded from cache persistence in this phase.
 * To enable persistence for a filter type, remove it from this set.
 */ export const NonPersistedFilterFields = new Set([
    DynamicFilterField
]);
/**
 * Maximum number of saved dynamic filters per plan (per user + per plan).
 */ export const MAX_DYNAMIC_FILTERS_PER_PLAN = 10;
/**
 * Maximum number of saved dynamic filters per user across all scopes (app-wide).
 */ export const MAX_DYNAMIC_FILTERS_TOTAL = 100;
/**
 * Maximum number of characters allowed in a saved dynamic filter title.
 * Titles may be seeded from a task description, but are intentionally capped to keep saved filter names concise.
 */ export const MAX_DYNAMIC_FILTER_TITLE_LENGTH = 35;
/**
 * Maximum number of characters allowed in a saved dynamic filter description
 * (the Catalyst prompt / task list description).
 */ export const MAX_DYNAMIC_FILTER_DESCRIPTION_LENGTH = 500;
